var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBussinesUnit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2168_8229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 7.77778V0H0V35H39V7.77778H19.5ZM7.8 31.1111H3.9V27.2222H7.8V31.1111ZM7.8 23.3333H3.9V19.4444H7.8V23.3333ZM7.8 15.5556H3.9V11.6667H7.8V15.5556ZM7.8 7.77778H3.9V3.88889H7.8V7.77778ZM15.6 31.1111H11.7V27.2222H15.6V31.1111ZM15.6 23.3333H11.7V19.4444H15.6V23.3333ZM15.6 15.5556H11.7V11.6667H15.6V15.5556ZM15.6 7.77778H11.7V3.88889H15.6V7.77778ZM35.1 31.1111H19.5V27.2222H23.4V23.3333H19.5V19.4444H23.4V15.5556H19.5V11.6667H35.1V31.1111ZM31.2 15.5556H27.3V19.4444H31.2V15.5556ZM31.2 23.3333H27.3V27.2222H31.2V23.3333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_8229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussinesUnit);
export default __webpack_public_path__ + "static/media/BussinesUnit.563e24478a59b46a42773dc90e678450.svg";
export { ForwardRef as ReactComponent };